/**
 * Map Preferred unit to text.
 * @param resources - Object with translation keys.
 * @returns long text for chosen unit.
 */
export const mapPreferredUnitToText = (unit: string, resources: any): string => {
    switch (unit) {
        case 'KG':
            return resources.accountProfileLongTextKilogram;
        case 'LB':
            return resources.accountProfileLongTextPound;
        default:
            return resources.accountProfileUnitNotFound;
    }
};
